import Client from '../HttpClient';

const baseUrl = '/api/auth';

const login = (username, password) => {
	return Client.post(`${baseUrl}/login-proxy`, {
		UserName: username,
		Password: password,
	});
};

const listUser = () => {
	return Client.get(`${baseUrl}/usernames`);
};

const gatewayToken = (Token, MerchantId, BranchId) => {
	let headers = {};
	if (Token) headers = { ...headers, Token };
	if (MerchantId) headers = { ...headers, MerchantId };
	if (BranchId) headers = { ...headers, BranchId };
	return Client.post(
		`${baseUrl}/gateway-token`,
		{},
		{},
		{
			headers,
		}
	);
};

export default {
	login,
	listUser,
	gatewayToken,
};
